<div>
  <input #carrierInput matInput [formControl]="formControl" [matAutocomplete]="auto" placeholder="Alle bærere" (click)="$event.target.select()">
</div>
<mat-autocomplete panelWidth="40em" #auto="matAutocomplete" (optionSelected)="autocompleteCarrierSelected($event)">
  <mat-option *ngFor="let carrier of filteredCarriers | async" [value]="getCarrierDisplayName(carrier)">
    {{ carrier.Name }}
  </mat-option>
</mat-autocomplete>
